import { bopApi } from '@/lib/api/client';

const PATH = 'v1/exchange/status';

export interface ExchangeStatusResponse {
  killed: boolean;
  frozen: boolean;
}

export type ExchangeStatus = 'active' | 'frozen' | 'disabled';

// Mirrors the legacy mapping (bop-ui server/api/exchange/status.get.ts):
// killed wins over frozen; anything else is active.
export const deriveExchangeStatus = ({ killed, frozen }: ExchangeStatusResponse): ExchangeStatus => {
  if (killed) return 'disabled';
  if (frozen) return 'frozen';
  return 'active';
};

export const getExchangeStatus = () => bopApi.get(PATH).json<ExchangeStatusResponse>();
